import { IAssessmentPartition, normalizeSectionCaptionOvrd } from '../models/assessment-framework';
import { ISectionDef } from '../../../ui-testtaker/view-tt-test-runner/view-tt-test-runner.component';

export const extractSectionParams = (partition:IAssessmentPartition) : Partial<ISectionDef> => {
  return {
    caption: partition.description,
    hasCalculator: partition.isCalculatorEnabled,
    is_attestation: partition.is_attestation,
    hasNotepad: !partition.isNotepadDisabled,
    hasFormulas: partition.isFormulaSheetEnabled,
    areQuestionsSkippable: partition.areQuestionsSkippable,
    isShuffleDisabled: !partition.isShuffled,
    disableScoring: partition.disableScoring,
    disableFlagging: partition.disableFlagging,
    msgReqFill: partition.msgReqFill,
    disableLeftBar: partition.disableLeftBar,
    submissionText: partition.submissionText,
    notepadText: partition.notepadText,
    preambleThumbnail: partition.preambleThumbnail,
    preambleThumbnailSelected: partition.preambleThumbnailSelected,
    preambleThumbnailText: partition.preambleThumbnailText,
    isConditional: partition.isConditional,
    conditionOnItem: partition.conditionOnItem,
    conditionOnOption: partition.conditionOnOption,
    sidebarThumbnailEn: partition.sidebarThumbnailEn,
    sidebarThumbnailFr: partition.sidebarThumbnailFr,
    sectionId: partition.id,
    sectionCaptionOvrd: normalizeSectionCaptionOvrd(partition.sectionCaptionOvrd),
  }
}
